import { createReducer } from '@reduxjs/toolkit';

import {
  loadPayoutAvailableMethodsStart,
  loadPayoutAvailableMethodsSuccess,
  loadPayoutAvailableMethodStart,
  loadPayoutAvailableMethodSuccess,
  resetPayoutAvailableMethod,
} from './actions';
import { IPaymentRoutingReducer } from './types';

const initialState: IPaymentRoutingReducer = {
  methods: {
    isLoading: false,
    isLoaded: false,
    data: {},
  },
  method: {
    isLoading: false,
    isLoaded: false,
    data: {},
  },
};

const payoutAvailableMethodsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(loadPayoutAvailableMethodsStart, (state) => ({
      ...state,
      methods: {
        ...state.methods,
        isLoading: true,
      },
    }))
    .addCase(loadPayoutAvailableMethodsSuccess, (state, action) => ({
      ...state,
      methods: {
        isLoading: false,
        isLoaded: true,
        data: action.payload,
      },
    }))
    .addCase(loadPayoutAvailableMethodStart, (state) => ({
      ...state,
      method: {
        ...state.method,
        isLoading: true,
      },
    }))
    .addCase(loadPayoutAvailableMethodSuccess, (state, action) => ({
      ...state,
      method: {
        isLoading: false,
        isLoaded: true,
        data: action.payload,
      },
    }))
    .addCase(resetPayoutAvailableMethod, (state) => ({
      ...state,
      method: {
        ...initialState.method,
      },
    }));
});

export default payoutAvailableMethodsReducer;
